import { EarthArrowUpIcon } from './EarthArrowUpIcon';

/**
 * author: frankgrinaert
 * id 9D8CB6F6-F5F6-4D11-8194-F392B52601F3
 * name earth-arrow-up
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-arrow-up.svg
 * tags
 */
export const WorldArrowUpIcon = EarthArrowUpIcon;
export default WorldArrowUpIcon